$shm_check_all $mol_check_box
	checks /$mol_check
	Icon $mol_icon_check_all
